<script lang="ts">
  export let className: string = "";
</script>

<div class="embla__slide {className}">
  <slot />
</div>
